import moment from 'moment';
import * as XLSX from "xlsx"
const pathSpliter = (path,index)=>{
     let divs =  path.split('/')
     return divs[index];
}
const authInfoSeter = JSON.parse(sessionStorage.getItem('auth_info'));

const accessChecker = (accessName)=> {
      let auth = JSON.parse(sessionStorage.getItem('auth_info'));
      if (!auth) return -1;
      if (!auth.access) return 0;
      try {
            let access = JSON.parse(auth.access);
            if (!Array.isArray(access)) return 0;
            return access.indexOf(accessName);
      } catch(e) {
            return 0;
      }
}
const checkAuthBranchWare = (branchID)=>{
      if(authInfoSeter.userInfo.user_branch_id==branchID ){
            return true
      }else{
            return false
      }
}

const checkIntNum = (number)=>{
      return !Number.isInteger(parseFloat(number))?true:false
}

let getDateTimeFromISODT = (isoString)=>{
      
      var date = moment(isoString);
      var dateComponent = date.utc().format('Y-MM-DD');
      var timeComponent = date.utc().format('hh:mm');
      return dateComponent+'T'+timeComponent
      
}
const dateTimeFormat  =  'DD MMM Y hh:mm zz a';
const currentDateTime = ()=>{
      return moment().toISOString()
}

const currentDateStartTime = ()=>{
      return moment().startOf('day').toISOString()
}
const currentDateEndTime = ()=>{
      return moment().endOf('day').toISOString()
}

const exportToExcel = (data, fileName = "Stock_Data.xlsx", columnWidths = []) =>{
    const worksheet = XLSX.utils.json_to_sheet(data)

    if(columnWidths.length) worksheet['!cols'] = columnWidths
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, "stock_report")

    XLSX.writeFile(workbook, fileName)
}

const convertNumberToWords = (amountToWord) => {
    var words = new Array();
    words[0] = "";
    words[1] = "One";
    words[2] = "Two";
    words[3] = "Three";
    words[4] = "Four";
    words[5] = "Five";
    words[6] = "Six";
    words[7] = "Seven";
    words[8] = "Eight";
    words[9] = "Nine";
    words[10] = "Ten";
    words[11] = "Eleven";
    words[12] = "Twelve";
    words[13] = "Thirteen";
    words[14] = "Fourteen";
    words[15] = "Fifteen";
    words[16] = "Sixteen";
    words[17] = "Seventeen";
    words[18] = "Eighteen";
    words[19] = "Nineteen";
    words[20] = "Twenty";
    words[30] = "Thirty";
    words[40] = "Forty";
    words[50] = "Fifty";
    words[60] = "Sixty";
    words[70] = "Seventy";
    words[80] = "Eighty";
    words[90] = "Ninety";
    let amount = amountToWord == null ? "0.00" : amountToWord.toString();
    var atemp = amount.split(".");
    var number = atemp[0].split(",").join("");
    var n_length = number.length;
    var words_string = "";
    if (n_length <= 9) {
      var n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
      var received_n_array = new Array();
      for (var i = 0; i < n_length; i++) {
        received_n_array[i] = number.substr(i, 1);
      }
      for (var i = 9 - n_length, j = 0; i < 9; i++, j++) {
        n_array[i] = received_n_array[j];
      }
      for (var i = 0, j = 1; i < 9; i++, j++) {
        if (i == 0 || i == 2 || i == 4 || i == 7) {
          if (n_array[i] == 1) {
            n_array[j] = 10 + parseInt(n_array[j]);
            n_array[i] = 0;
          }
        }
      }
      let value = "";
      for (var i = 0; i < 9; i++) {
        if (i == 0 || i == 2 || i == 4 || i == 7) {
          value = n_array[i] * 10;
        } else {
          value = n_array[i];
        }
        if (value != 0) {
          words_string += words[value] + " ";
        }
        if (
          (i == 1 && value != 0) ||
          (i == 0 && value != 0 && n_array[i + 1] == 0)
        ) {
          words_string += "Crores ";
        }
        if (
          (i == 3 && value != 0) ||
          (i == 2 && value != 0 && n_array[i + 1] == 0)
        ) {
          words_string += "Lakhs ";
        }
        if (
          (i == 5 && value != 0) ||
          (i == 4 && value != 0 && n_array[i + 1] == 0)
        ) {
          words_string += "Thousand ";
        }
        if (
          i == 6 &&
          value != 0 &&
          n_array[i + 1] != 0 &&
          n_array[i + 2] != 0
        ) {
          words_string += "Hundred and ";
        } else if (i == 6 && value != 0) {
          words_string += "Hundred ";
        }
      }
      words_string = words_string.split("  ").join(" ");
    }
    return words_string;
  };

const defaultRecentDateKeys = [
  "updated_isodt",
  "created_isodt",
  "updated_at",
  "created_at",
];

const defaultRecentIdKeys = [
  "id",
  "prod_id",
  "order_id",
  "receiver_id",
  "delivery_id",
  "delivery_name_id",
  "email_cc_name_id",
  "area_id",
  "prod_cat_id",
  "prod_brand_id",
  "prod_color_id",
  "prod_floor_id",
  "prod_rack_id",
  "prod_unit_id",
  "branch_id",
  "user_id",
];

const normalizeSortNumber = (value) => {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string" && value.trim() !== "") {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) return parsed;
  }
  return null;
};

const getRecentSortValue = (row, preferredDateKeys = [], preferredIdKeys = []) => {
  if (!row || typeof row !== "object" || Array.isArray(row)) return 0;

  const rowKeys = Object.keys(row);
  const dateKeys = [
    ...preferredDateKeys,
    ...rowKeys.filter((key) =>
      defaultRecentDateKeys.some((suffix) => key.toLowerCase().endsWith(suffix))
    ),
  ];

  for (const key of dateKeys) {
    const value = row[key];
    if (!value) continue;
    const timestamp = new Date(value).getTime();
    if (!Number.isNaN(timestamp)) return timestamp;
  }

  const idKeys = [
    ...preferredIdKeys,
    ...defaultRecentIdKeys,
    ...rowKeys.filter((key) => key.toLowerCase().endsWith("_id")),
  ];

  for (const key of idKeys) {
    const numericValue = normalizeSortNumber(row[key]);
    if (numericValue !== null) return numericValue;
  }

  return 0;
};

const sortRecordsNewestFirst = (rows, options = {}) => {
  if (!Array.isArray(rows)) return [];

  const { dateKeys = [], idKeys = [] } = options;
  return [...rows].sort((left, right) => {
    const rightValue = getRecentSortValue(right, dateKeys, idKeys);
    const leftValue = getRecentSortValue(left, dateKeys, idKeys);
    return rightValue - leftValue;
  });
};

export {convertNumberToWords, exportToExcel,pathSpliter,authInfoSeter,accessChecker,checkAuthBranchWare,dateTimeFormat,checkIntNum,currentDateTime,getDateTimeFromISODT,currentDateStartTime,currentDateEndTime,sortRecordsNewestFirst}
